// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"60a9d5cd","373":"e1ac73da","377":"bae748ac","460":"d8915019"}[chunkId] + ".chunk.js";
};